import * as staticUrls from "../constants/static-urls";
import {FAKTUROMANIA_KALKULATOR_WYNAGRODZEN_PAGE_URL} from "../constants/static-urls";

/** ELEMENTY MENU APLIKACJA */
export const APLIKACJA_MENU_WIDE_ITEM_ELEMENTS: HeaderMegamenuDropdownItemMenuElementData[] = [
    {
    elementName: 'Cennik',
    elementLinkTo: staticUrls.FAKTUROMANIA_CENNIK_PAGE_URL,
    elementChildren: []
  },
  {
    elementName: 'Program do faktur',
    elementLinkTo: staticUrls.FAKTUROMANIA_PROGRAM_DO_FAKTUR_PAGE_URL,
    elementChildren: []
  },
  {
    elementName: 'O nas',
    elementLinkTo: staticUrls.FAKTUROMANIA_NASZ_ZESPOL_PAGE_URL,
    elementChildren: []
  },
  {
    elementName: 'Regulaminy',
    elementLinkTo: 'elementLinkTo',
    elementChildren: [
      {
        elementName: 'Regulamin serwisu',
        elementLinkTo: staticUrls.FAKTUROMANIA_REGULAMIN_PAGE_URL,
        elementLinkNoFollow: true
      },
      {
        elementName: 'Polityka cookies',
        elementLinkTo: staticUrls.FAKTUROMANIA_COOKIES_PAGE_URL,
        elementLinkNoFollow: true
      }
    ]
  }
];

/** ELEMENTY MENU TWOJA SPÓŁKA */
export const TWOJA_SPOLKA_MENU_WIDE_ITEM_ELEMENTS: HeaderMegamenuDropdownItemMenuElementData[] = [
  // {
  //   elementName: 'Rejestracja spółek',
  //   elementLinkTo: staticUrls.FAKTUROMANIA_ZAKLADANIE_SPOLEK_ZOO_PAGE_URL,
  //   elementChildren: []
  // }
];

/** ELEMENTY MENU KALKULATORY */
export const KALKULATORY_MENU_WIDE_ITEM_ELEMENTS: HeaderMegamenuDropdownItemMenuElementData[] = [
  {
    elementName: 'Kalkulator wynagrodzeń',
    elementLinkTo: staticUrls.FAKTUROMANIA_KALKULATOR_WYNAGRODZEN_PAGE_URL,
    elementChildren: []
  }
];

/** ELEMENTY MENU USŁUGI */
export const USLUGI_MENU_DROPDOWN_ITEM_ELEMENTS: HeaderMegamenuDropdownItemMenuElementData[] = [];

export const USLUGI_SMALL_DEVICES_MENU_DROPDOWN_ITEM_ELEMENTS: HeaderMegamenuDropdownItemMenuElementData[] = [
  {
    elementName: 'Rejestracja spółek',
    elementLinkTo: staticUrls.FAKTUROMANIA_ZAKLADANIE_SPOLEK_ZOO_PAGE_URL,
    elementChildren: []
  },
    {
    elementName: 'Biuro rachunkowe',
      elementLinkTo: staticUrls.FAKTUROMANIA_BIURO_RACHUNKOWE_PAGE_URL,
    elementChildren: []
  },
];

/** ELEMENTY MENU BIURO_WIRTUALNE */
export const BIURO_WIRTUALNE_MENU_DROPDOWN_ITEM_ELEMENTS: HeaderMegamenuDropdownItemMenuElementData[] = [];

/** ELEMENTY MENU POMOC */
export const POMOC_MENU_DROPDOWN_ITEM_ELEMENTS: HeaderMegamenuDropdownItemMenuElementData[] = [
  {
    elementName: 'Baza wiedzy',
    elementLinkTo: staticUrls.FAKTUROMANIA_BAZA_WIEDZY_PAGE_URL,
    elementLinkOpenInNewTab: true,
    elementChildren: []
  },
  {
    elementName: 'Materiały szkoleniowe',
    elementLinkTo: staticUrls.FAKTUROMANIA_YOUTUBE_PAGE_URL,
    elementLinkOpenInNewTab: true,
    elementLinkNoFollow: true,
    elementChildren: []
  }
];

/** ELEMENTY MENU KONTAKT */
export const KONTAKT_MENU_DROPDOWN_ITEM_ELEMENTS: HeaderMegamenuDropdownItemMenuElementData[] = [];

/** ELEMENTY DO MENU NA MAŁE EKRANY */
export const SMALL_DEVICE_MENU_DROPDOWN_ITEM_ELEMENTS: HeaderMegamenuDropdownItemMenuElementData[] = [
  {
    elementName: 'Cennik',
    elementLinkTo: staticUrls.FAKTUROMANIA_CENNIK_PAGE_URL,
    elementChildren: []
  },
  {
    elementName: 'Program do faktur',
    elementLinkTo: staticUrls.FAKTUROMANIA_PROGRAM_DO_FAKTUR_PAGE_URL,
    elementChildren: []
  },
  {
    elementName: 'O nas',
    elementLinkTo: staticUrls.FAKTUROMANIA_NASZ_ZESPOL_PAGE_URL,
    elementChildren: []
  },
  {
    elementName: 'Regulamin serwisu',
    elementLinkTo: staticUrls.FAKTUROMANIA_REGULAMIN_PAGE_URL,
    elementLinkNoFollow: true
  },
  {
    elementName: 'Polityka cookies',
    elementLinkTo: staticUrls.FAKTUROMANIA_COOKIES_PAGE_URL,
    elementLinkNoFollow: true
  }
];


// WEBPACK FOOTER //
// ./src/constants/header-menu-data.ts